<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Shop Bundle ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <r-smart-offer-bundle-shop-type :model.sync="model.type" label="Type"/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Name"
              v-model.trim="model.name"
              v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Key"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="4">
            <v-text-field
              label="Segment"
              v-model.trim="model.segment"
              v-ascii-only
            />
          </v-col>
        </v-row>

        <v-expansion-panels>
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
          <r-trigger-panel :items.sync="model.triggersProgress" title="Progress"/>
        </v-expansion-panels>
        <v-row dense class="mt-4"/>
        <v-expansion-panels>
          <r-panel title="Settings">
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-checkbox v-model="model.defaultRewardIcon" label="Default Reward Icon" hide-details/>
              </v-col>
            </v-row>
          </r-panel>
          <r-product-panel :items.sync="model.products" :kinds="kinds" title="Products"/>
          <r-reward-bunch-panel :model.sync="model.reward" title="Rewards" label="Chest" :points="true"/>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import {SmartOfferBundleShop} from "@/modules/redactor/models/smart-offer/bundle-shop/SmartOfferBundleShop";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RProductPanel from "@/modules/redactor/views/product/r-product-panel.vue";
import RSmartOfferBundleShopType from "@/modules/redactor/views/smart-offer/bundle-shop/r-smart-offer-bundle-shop-type.vue";
import RRewardBunchPanel from "@/modules/redactor/views/reward/r-reward-bunch-panel.vue";
import RTriggerPanel from "@/modules/redactor/views/trigger/r-trigger-panel.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

export default {
  name: "r-smart-offer-bundle-shop",
  components: {RPanel, RTriggerPanel, RRewardBunchPanel, RSmartOfferBundleShopType, RProductPanel, RGuardMoneyPanel, RGuardPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleShop(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    kinds() {
      if (!this.model) {
        return [];
      } else if (this.model.type.id === 3 || this.model.type.id === 5) {
        return [ProductGroupKind.LONG_OFFER];
      } else {
        return [ProductGroupKind.SMART_OFFERS];
      }
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleShop();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>
